import { EntityManager, IEntity } from '@proximus/entity-manager';
import {
  UpdatePrepaidSettingsEntity,
  UpdatePrepaidSettingsMsisdnEntity,
} from '../configs/entity.config';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrepaidSettingsService {
  constructor() {}

  deletePrepaidSettings(msisdn: string): Observable<IEntity<any>> {
    const iEntity = EntityManager.createEntity(UpdatePrepaidSettingsEntity, {
      msisdn,
    });
    return EntityManager.deleteEntity(iEntity);
  }

  updatePrepaidSettings(
    msisdn: string,
    threshold: any,
  ): Observable<IEntity<any>> {
    const iEntity = EntityManager.createEntity(UpdatePrepaidSettingsEntity, {
      msisdn,
    });
    if (threshold !== undefined) {
      iEntity.value = { threshold };
    }
    return EntityManager.updateEntity(iEntity);
  }

  updatePrepaidSettingsMsisdn(
    msisdn: string,
    proxiWorld: any,
  ): Observable<IEntity<any>> {
    const iEntity = EntityManager.createEntity(
      UpdatePrepaidSettingsMsisdnEntity,
      {
        msisdn,
      },
    );
    iEntity.value = { msisdn, proxiWorld };
    return EntityManager.updateEntity(iEntity);
  }
}
